import appConfig from './appConfig';

export const mapCall = (call: any) => {
  const transformIdentity = (identity: any) => ({
    displayName: identity._display_name,
    parameters: identity._parameters,
    uri: identity._uri.toString(),
  });
  const { emitter, on, once, session, streams, userAgent, ...callCopy } = call;
  const { body, call_id, cseq, data, from_tag, headers, method, to_tag } =
    session._request;
  const request = {
    body,
    callId: call_id,
    cseq,
    data,
    fromTag: from_tag,
    headers,
    method,
    toTag: to_tag,
    from: transformIdentity(session._request.from),
    to: transformIdentity(session._request.to),
  };
  callCopy.session = {
    audioMuted: session._audioMuted,
    cancelReason: session._cancel_reason,
    contact: session._contact,
    direction: session._direction,
    fromTag: session._from_tag,
    iceReady: session._iceReady,
    id: session._id,
    isCanceled: session._is_canceled,
    isConfirmed: session._is_confirmed,
    lateSdp: session._late_sdp,
    localHold: session._localHold,
    localMediaStreamLocallyGenerated: session._localMediaStreamLocallyGenerated,
    remoteHold: session._remoteHold,
    remoteIdentity: transformIdentity(session._remote_identity),
    request,
    rtcReady: session._rtcReady,
    status: session._status,
  };
  return callCopy;
};

export const mapOngoingCalls = () => {
  if (appConfig.extension) {
    const calls = appConfig.extension.ongoingCalls.map(mapCall);

    return calls;
  }
  return undefined;
};
